module.exports = __webpack_public_path__ + "static/media/car-mechanic.3d1c23b0.svg";